// We want to be able to fetch ALL records for a particular endpoint. Until that exists just use a hardcoded huge limit
// TODO: remove the need for this by making the API able to return all
export const TEMP_MAX_ITEMS = 10000
